enum SortListOptionsEnum {
	default = 'default',
	aisleLocation = 'aisleLocation',
	packageSize = 'packageSize',
	packageWeight = 'packageWeight'
}

export default SortListOptionsEnum;
